import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

// Format experience dates
export const formatExperienceDate = (startDate: string, endDate: string | "Present") => {
  const formatDate = (date: string) => {
    if (date === "Present") return "Present"
    const [year, month] = date.split("-")
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    return `${months[parseInt(month) - 1]} ${year}`
  }
  return `${formatDate(startDate)} - ${formatDate(endDate)}`
}

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
